import { z } from "zod";

import { MetadataSchema } from "api/schemas/common";

const UsProviderGroupClinicSchema = z.object({
  created_at: z.string(),
  feature_flags: z.array(z.string()),
  id: z.number(),
  name: z.string(),
  payer_id: z.number(),
  updated_at: z.string(),
});

export const GetUsProviderGroupClinicsResponseSchema = z.object({
  items: z.array(UsProviderGroupClinicSchema),
});

export const ClinicPartnerInvitationPayloadSchema = z.object({
  date_of_birth: z.string().optional(),
  email: z.union([z.email(), z.literal("")]).optional(),
  external_partner_user_id: z.string().min(1),
  first_name: z.string().min(1),
  invited_joint: z.string().optional(),
  last_name: z.string().min(1),
  phone_country_code: z.string().min(1),
  phone_number: z.string().min(1),
  title: z.string().optional(),
  us_provider_group_clinic_id: z.number(),
});
export type ClinicPartnerInvitationPayload = z.infer<typeof ClinicPartnerInvitationPayloadSchema>;

export const PostClinicPartnerInvitationResponseSchema = z.object({
  created_at: z.string(),
  email: z.email().nullable(),
  expires_at: z.string(),
  id: z.number(),
  locale: z.string(),
  name: z.string(),
  phone_number: z.string(),
});
export type PostClinicPartnerInvitationResponse = z.infer<typeof PostClinicPartnerInvitationResponseSchema>;

const PostClinicPartnerInvitationArgsSchema = z.object({
  payload: ClinicPartnerInvitationPayloadSchema,
});
export type PostClinicPartnerInvitationArgs = z.infer<typeof PostClinicPartnerInvitationArgsSchema>;

const GetClinicPartnerInvitationsArgsSchema = z.object({
  params: z.object({
    clinic_partner_ids: z.number().optional(),
    limit: z.number(),
    page: z.number(),
  }),
});
export type GetClinicPartnerInvitationsArgs = z.infer<typeof GetClinicPartnerInvitationsArgsSchema>;

const ClinicPartnerInvitationSchema = z.object({
  clinic_partner_id: z.number().nullable(),
  created_at: z.string(),
  external_id: z.string().nullable(),
  id: z.number(),
  last_reminder_at: z.string().nullable(),
  patient_name: z.string(),
  reminder_count: z.number(),
  sent_at: z.string().nullable(),
  treatment_type: z.string(),
});

export const GetClinicPartnerInvitationsResponseSchema = z.object({
  items: z.array(ClinicPartnerInvitationSchema),
  metadata: MetadataSchema,
});
export type GetClinicPartnerInvitationsResponse = z.infer<typeof GetClinicPartnerInvitationsResponseSchema>;
